module.exports = __webpack_public_path__ + "assets/share.3bac4219d75a73d27b5366149b21dcaf.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/share.png
 ** module id = 213
 ** module chunks = 0
 **/